<template>
  <b-modal
    ref="configurationEventModal"
    centered
    modal-class="configuration-event-modal"
    @hidden="hide"
  >
    <div slot="modal-title">
      <span v-if="holidayId">{{ $t('component.calendar.update') }} </span>
      <span v-else>{{ $t('configuration.actions.add') }} </span>
    </div>
    <b-row class="px-3 py-2">
      <b-col cols="12">
        <div class="form-label">
          <label>{{ $t('configuration.modal.calendar.publicHolidayName') }}</label>
        </div>
        <vt-input
          v-model="holidayName"
          v-validate="'required'"
          :class="{ requiredform: (showErrors && !holidayName) }"
          name="holidayName"
          class="form-control-sm"
        />
      </b-col>
      <b-col
        cols="12"
        class="mt-3"
      >
        <div class="form-label">
          <label>{{ $t('configuration.modal.calendar.startDate') }}</label>
        </div>
        <vt-date-picker
          :model="holidayStartingDateSelected"
          :class="{ requiredform: (showErrors && !holidayStartingDateSelected) }"
          class="p-0"
          type="date"
          :not-after="holidayEndingDateSelected"
          @update="holidayStartingDateSelected = $event"
          @clear="holidayStartingDateSelected = null"
        />
      </b-col>
      <b-col
        cols="12"
        class="mt-3"
      >
        <div class="form-label">
          <label>{{ $t('configuration.modal.calendar.endDate') }}</label>
        </div>
        <vt-date-picker
          :model="holidayEndingDateSelected"
          :class="{ requiredform: (showErrors && !holidayEndingDateSelected) }"
          class="p-0"
          type="date"
          :not-before="holidayStartingDateSelected"
          @update="holidayEndingDateSelected = $event"
          @clear="holidayEndingDateSelected = null"
        />
      </b-col>
    </b-row>
    <div
      slot="modal-footer"
      class="footer-banner px-2"
      style="width:100%;"
    >
      <div class="row">
        <div class="col-auto text-left">
          <b-button
            size="sm"
            variant="outline-secondary"
            data-dismiss="modal"
            @click="hide"
          >
            {{ $t('global.cancel') }}
          </b-button>
        </div>
        <div class="col text-right">
          <b-button
            v-if="holidayId"
            size="sm"
            class="btn__outline mr-2"
            @click="deleteLaboratoryHoliday"
          >
            <i
              class="fal fa-trash-alt mr-2"
              aria-hidden="true"
            />
            {{ $t('configuration.actions.delete') }}
          </b-button>
          <b-button
            v-if="!holidayId"
            size="sm"
            class="btn--primary"
            @click="createUpdatePersonnelEvent"
          >
            <i
              class="fal fa-check mr-2"
              aria-hidden="true"
            />
            {{ $t('configuration.actions.add') }}
          </b-button>
          <b-button
            v-if="holidayId"
            size="sm"
            class="btn--primary"
            @click="createUpdatePersonnelEvent"
          >
            <i
              class="fal fa-check mr-2"
              aria-hidden="true"
            />
            {{ $t('component.calendar.update') }}
          </b-button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>

import moment from 'moment'

export default {
    name: 'ConfigurationEventModal',
    data() {
        return {
            holidayStartingDateSelected: null,
            holidayName: '',
            holidayEndingDateSelected: null,
            showErrors: false,
            holidayId: null
        }
    },
    methods: {
        show(selectedEvent) {
            this.$_cleanComponentData()
            if (selectedEvent) {
                this.holidayId = selectedEvent.id
                this.holidayName = selectedEvent.name
                this.holidayStartingDateSelected = moment(selectedEvent.startingDate)
                this.holidayEndingDateSelected = moment(selectedEvent.endingDate)
            }
            this.$refs.configurationEventModal.show()
        },
        async deleteLaboratoryHoliday() {
            this.$emit('deleteEvent', this.holidayId)
            this.hide()
        },
        async createUpdatePersonnelEvent() {
            const validForm = await this.$validator.validate()
            const validDateRange = this.holidayStartingDateSelected && this.holidayEndingDateSelected
            if (validForm && validDateRange) {
                if (!this.holidayId) {
                    this.$emit('createEvent', this.$data)
                } else {
                    this.$emit('updateEvent', this.$data)
                }
                this.hide()
            } else {
                this.showErrorModalGlobal(this.$t('studyRequest.general.requiredFieldsNotice'))
                this.showErrors = true
            }
        },
        hide() {
            this.$refs.configurationEventModal.hide()
        }
    }
}
</script>

<style lang="scss">
    .requiredform {
        border-color: red !important;
    }
    .configuration-event-modal .modal-dialog {
        max-width: 350px !important;
    }
</style>
